import AsyncStorage from '@react-native-async-storage/async-storage';
import { fromPromise } from 'xstate5';

import { DIETARY_PREFERENCES_KEY } from './constants';
import { type DietaryPreferencesTypes } from './types';

// ─── Hydration ───────────────────────────────────────────────────────────────

export const hydrateDietaryPreferences = fromPromise<void, DietaryPreferencesTypes>(
  async (args) => {
    await AsyncStorage.setItem(DIETARY_PREFERENCES_KEY, JSON.stringify(args.input));
  },
);

export const rehydrateDietaryPreferences = fromPromise(async () => {
  const dietaryPreferences = await AsyncStorage.getItem(DIETARY_PREFERENCES_KEY);

  if (!dietaryPreferences) return {};

  return JSON.parse(dietaryPreferences);
});

// ─── Remote Preferences ──────────────────────────────────────────────────────

/**
 * NOTE: External actor
 */
export const fetchCustomerDietaryPreferences = fromPromise<
  DietaryPreferencesTypes,
  DietaryPreferencesTypes
>(async () => {
  throw new Error('fetchCustomerDietaryPreferences implementation required');
});

/**
 * NOTE: External actor
 */
export const updateRemotePreferences = fromPromise<void, DietaryPreferencesTypes>(async () => {
  throw new Error('updateRemotePreferences implementation required');
});
